const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImmigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.13,330.34c-9.25,40.48-22.23,79.93-39.54,105.18-9.88,14.44-21.19,24.23-34,26.92-67.78,14.2-261.42,9-294.34-4.52-6.13-2.52-14-11.41-22.58-24.83-15-23.59-31.85-61.2-44.16-103C13.19,268,5,196.77,27.87,148.73,51.51,99.2,98.2,68,138.88,49.23A225.65,225.65,0,0,1,284.13,34.39c7.95,1.84,16.56,4,25.82,6.55,63.25,17.43,174.27,99.4,174.92,147.17C485.18,211,479.55,271.75,466.13,330.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.13,330.34c-9.25,40.48-22.23,79.93-39.54,105.18-9.88,14.44-21.19,24.23-34,26.92-67.78,14.2-261.42,9-294.34-4.52-6.13-2.52-14-11.41-22.58-24.83-15-23.59-31.85-61.2-44.16-103C13.19,268,5,196.77,27.87,148.73,51.51,99.2,98.2,68,138.88,49.23A225.65,225.65,0,0,1,284.13,34.39c7.95,1.84,16.56,4,25.82,6.55,63.25,17.43,174.27,99.4,174.92,147.17C485.18,211,479.55,271.75,466.13,330.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.06,284.8c-2.47,14.86-5.43,30.27-8.93,45.54-9.25,40.48-22.23,79.93-39.54,105.18-9.88,14.44-21.19,24.23-34,26.92-67.78,14.2-261.42,9-294.34-4.52-6.13-2.52-14-11.41-22.58-24.83-15-23.59-31.85-61.2-44.16-103-4.32-14.65-8.08-29.82-11-45.07l76.07-31.9,26.06,1.45,5.07,1.45,14.48-23.17,40.53-29.68L200.09,209l45.6,102.8,24.62-8.69,14.47-28.23,10.86-2.9,39.09-41.26L369.48,238l3.62,10.86L389,266.18l50,22.44,12.3-18.82,14.48,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.06,284.8q-1,5.88-2.07,11.87c-2,11.11-4.28,22.43-6.86,33.67-9.25,40.48-22.23,79.93-39.54,105.18-9.88,14.44-21.19,24.23-34,26.92-67.78,14.2-261.42,9-294.34-4.52-6.13-2.52-14-11.41-22.58-24.83-15-23.59-31.85-61.2-44.16-103-4.32-14.65-8.08-29.82-11-45.07l76.07-31.9,26.06,1.45,5.07,1.45,14.48-23.17L178,206.69l4.76-3.49L200.09,209l45.6,102.8,24.62-8.69,14.47-28.23,10.86-2.9,39.09-41.26L369.48,238l3.62,10.86L389,266.18l50,22.44,9.34-14.29,3-4.53,14.48,1.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.09 208.99 245.69 311.79 234.84 314.68 191.4 296.59 202.98 283.55 223.25 294.41 193.57 238.67 196.47 226.37 178.37 207.55 177.95 206.69 182.71 203.2 200.09 208.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.03 266.18 438.98 288.62 428.12 297.31 367.31 293.69 364.41 283.55 381.06 272.7 362.24 261.84 359.35 253.15 345.59 247.36 334.73 230.71 369.48 237.95 373.1 248.81 389.03 266.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.06,284.8q-1,5.88-2.07,11.87L457.8,277l-9.48-2.71,3-4.53,14.48,1.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-169"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165.61 335.23 159.5 339.3 164.09 347.97 170.2 345.93 173.26 340.83 165.61 335.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.05 364.78 160.01 371.4 164.59 373.44 166.12 367.84 162.05 364.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.7 358.69 178.35 357.59 177.19 360.62 180.87 361.42 182.7 358.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83,356.22c-2.13,4.7-9.05,11.81-11,12.77-2.43,1.22-14,15.17-14,15.17l-4.85,14-7.28,13.35-14.9,6.68-20.3,9.1-3.9,5.84C62,411.64,46.84,378.6,35,341.38q-1.79-5.56-3.46-11.26l5-1.13,64.32-14.62s36.41,6.07,39.44,7.89,10.93,27.31,12.14,30.95A4.4,4.4,0,0,1,151.83,356.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83,356.22l-24.43,2.45,6.11-24.46L105,325,36.47,329l64.32-14.62s36.41,6.07,39.44,7.89,10.93,27.31,12.14,30.95A4.4,4.4,0,0,1,151.83,356.22Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.13,327.12v3.22l-.48,2.08c-2.46,10.63-5.19,21.16-8.18,31.37-2.37,8.12-4.92,16-7.65,23.62-6.66,18.58-14.38,35.2-23.23,48.11l-24-20.4L382.38,403l-7.28-20L350.21,361.1s-5.46-15.78-3-20.63a43.43,43.43,0,0,1,5.7-7.08c7.08-7.68,18.23-18.15,20.4-19C376.31,313.16,466.13,327.12,466.13,327.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.13,327.12v3.22l-.48,2.08-42.22-4.84,4.59,4.08-17.83,6.12-35.67-18.35-21.64,14c7.08-7.68,18.23-18.15,20.4-19C376.31,313.16,466.13,327.12,466.13,327.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.47,363.79c-2.37,8.12-4.92,16-7.65,23.62a30.88,30.88,0,0,1-2.95-1.74c-19.36-12.74-27-12.74-27-12.74l-2.55-9.68,38.72,1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-169"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.41,176.32s-6.61-16.58-20.33-18.54S388.87,173.71,378.42,175s-13.72-11.1-21.56-7.18-7.18,13.72-11.76,15-12.41-3.92-15,1.31-5.23,11.11-5.23,11.11a31.65,31.65,0,0,1-9.79,3.91c-5.88,1.31-12.42,0-13.72,2.62H466s.66-15-9.14-19S436.1,191.64,427.41,176.32Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.21,182s-3-7.63-9.36-8.53-8.38,7.33-13.19,7.93-6.32-5.11-9.92-3.31-3.31,6.32-5.42,6.92-5.71-1.8-6.91.6S53,190.75,53,190.75a14.41,14.41,0,0,1-4.51,1.81c-2.71.6-5.71,0-6.31,1.2H118s.3-6.92-4.21-8.72S104.21,189.08,100.21,182Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,40.09s-2.83-7.11-8.71-8S234.52,39,230,39.53s-5.88-4.76-9.24-3.08-3.08,5.88-5,6.44-5.32-1.68-6.44.56-2.25,4.76-2.25,4.76a13.58,13.58,0,0,1-4.2,1.68c-2.52.56-5.32,0-5.88,1.12h70.58s.28-6.44-3.92-8.12S254.77,46.65,251,40.09Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48,44.71s-1.64-4.1-5-4.59-4.5,3.94-7.09,4.27S168,41.64,166,42.61s-1.78,3.39-2.91,3.71-3.07-1-3.71.33-1.29,2.74-1.29,2.74a7.74,7.74,0,0,1-2.43,1c-1.45.33-3.07,0-3.39.65H193s.16-3.72-2.26-4.69S185.63,48.5,183.48,44.71Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-169"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 403.5,
    cy: 75.8,
    r: 34.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.5,266.14l-9.71.92s-7.17-1.85-7.86-.23-.47,7.86.46,10.64.23,7.16.69,9.71,5.55,10.63,6.48,10.86,2.54-1.85,2.54-2.77.23-10.87.46-12,3.24-8.79,3.24-8.79l4.39-.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,276.58l-4-2.12-.14-7.5-1,.1s-7.17-1.85-7.86-.23-.47,7.86.46,10.64.23,7.16.69,9.71,5.55,10.63,6.48,10.86,2.54-1.85,2.54-2.77.23-10.87.46-12C161.71,282.48,163.07,278.93,164,276.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.69,211.8,217.75,249s-28.21,6.47-30.52,7.63-21.51,8.55-21.51,8.55l3.47,12.26s55-13.41,56.88-13.88,3.93-.69,4.86-2.08,19.88-32.37,22.89-37S230.46,216.89,227.69,211.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15,127.82s-22.66-8.93-25.12-8.63-27.74,3.7-28.82,4.17-34.16,28-35.52,29.38a10,10,0,0,0-2.22,3.57c-.74,1.48-2.34,4.93-2.59,5.55s-2.34,5.42-1.72,5.55,3.7-3,3.7-3-1.61,3.82-.25,3.2,3.94-4.68,4.31-5.05,6.41-3.82,6.41-3.82-1.85,4.31-1.35,5.54,1.72.87,1.85,0a3.67,3.67,0,0,1,1-2.58,10.26,10.26,0,0,0,1.85-4.94c0-1.23-.12-5.91-.12-5.91l29-14.28,21,.61,7.09,7.56s-4.31,36.67-4.47,37.44-1.69,2-2.16,3.7.31,2.47,1.39,2.77,19.26,7.09,23.58,9.1,6.78,3.39,7.86,2.62,3.39-5.24,3.39-5.24l12.17-23.43,5.55-8s16,2,23.73,1.85,9.86-3.24,10.33-4.78a9.18,9.18,0,0,1-7.09-2.31,43,43,0,0,1-6.32-8s-10.94-2.78-12.33-3.7-3.54-2.31-10.94-7.09-9.55-5.55-9.55-5.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,144.78s-4.31,36.67-4.47,37.44-1.69,2-2.16,3.7.31,2.47,1.39,2.77,19.26,7.09,23.58,9.1,6.78,3.39,7.86,2.62,3.39-5.24,3.39-5.24l12.17-23.43,5.55-8s16,2,23.73,1.85,9.86-3.24,10.33-4.78a9.18,9.18,0,0,1-7.09-2.31,43,43,0,0,1-6.32-8s-10.94-2.78-12.33-3.7-3.54-2.31-10.94-7.09-9.55-5.55-9.55-5.55l-13.56-6.32s-22.66-8.93-25.12-8.63-27.74,3.7-28.82,4.17a6.35,6.35,0,0,0-.61.42c1.36,2.47,4.12,7.9,4.92,12.83l21,.61Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.48,
    y1: 137.22,
    x2: 228.32,
    y2: 132.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "294.89 154.95 286.88 163.73 303.68 155.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,164.45s3.83-6.27,5.37-7.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.61,
    y1: 160.49,
    x2: 172.69,
    y2: 154.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.42,143.53l.8,7.71s-9.84,5.85-12.36,4.65-18.61-12-19.68-11.56-21.26,6.91-24.05,7.44-5.59.93-5.59.93l-6.78,7.85,14.76,5.18s10.77-6.78,14.89-9.31l8.24-5s16.35,9.84,16.88,9.71,15.28-8.78,15.28-8.78a23.29,23.29,0,0,0,5.32-2.52c1.73-1.33,4-6.66,4.58-6.85s1.14-1.39,1.14-1.39l-2.13-.14-5.18,5.85-3.33-1.06-.66-5.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.62 147.7 274.71 142.93 280.25 150.94 276.86 134.91 270.39 143.39 267.62 147.7",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,113.65s1.24,3.08.31,4.31l-1.38,1.85s4,4.47,3.08,5.55a7.27,7.27,0,0,1-2.47,1.69s-3.08,6.94-3.85,7.71-4.47-.46-4.47-.46l-13.25,13.4-.46-7.24-3.39-14.18.77-1.54s.77-11.86,5.24-15.87S282.26,105,286.26,107,289.65,113.65,289.65,113.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.87 134.3 277.49 131.9 276.98 137.82 280.87 134.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.55,116.42l2-.15s.3-2.31,1.07-2.62,1.55.61,2.93-.62,1.85-4.47,4.63-4.31,4.16,2.62,4.46,4.93,5.09-.47,5.71-2.16,1.69-5.86.15-6.32-4,2.31-4.16,1.85.46-7.09-2-6.47a6.69,6.69,0,0,0-3.39,1.69S277.17,97.47,273,98.7s-9.55,5.24-10,8.17.16,18.95,1.55,17.87,7.85-6.93,7.85-6.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.17,117.81s-.62-6.63-3.85-4.63-2,6.48-1.24,7.56,3.09.3,3.09.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,121.35s-.15,5.7.77,6.63a38,38,0,0,0,3.7,2.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,116.73a2.71,2.71,0,0,0-2.93-1.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.41,126.75s2.32.3,2.62,1.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,119c0,.64-.28,1.16-.62,1.16s-.62-.52-.62-1.16.28-1.15.62-1.15S287.5,118.33,287.5,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.76 126.28 267.15 140.46 259.45 149.25 259.6 127.36 263.76 126.28",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,124.43a23.42,23.42,0,0,1,2.93,5.86c.77,2.77,1.54,7.86,1.54,7.86s0,.62,2.62,0,3.39,1.08,3.7-2.16a29.78,29.78,0,0,0-2-11.71c-1.23-2.77,0-2.77-1.85-2.77S205.82,122.43,205.51,124.43Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.92,145.85s-5.4,5.55-4.78,6.48,9.4,9.86,11.4,10.48,4.16.61,6.63-2,.46-6.78-.62-8.78S310.3,145.24,308.92,145.85Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,113.65s-8,34-8.48,35.44,5.4,7.71,7.55,8.17,5.09-.62,5.55-2.93S322,148,322,148l.15-38.68s-5.7-9.4-6.93-9.4-6.79,5.09-6.32,6.17,1.54,3.69,2.62,4.16a17.46,17.46,0,0,0,2,.92A17.48,17.48,0,0,1,316.47,113.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,108.61s-4.44-11.14-5.52-10.84-6.63,2.62-6.63,3.24-.15,3.08.16,3.7a75.76,75.76,0,0,0,6.32,6c.46.31.3.62,1.69,0s2.47-2,1.54-2.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,102.32s-2.46.77-2.38,1.78,2.13,3.23,2.64,3.32,1.53-.26,1.53-.85A30.24,30.24,0,0,0,309.1,102.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.55,105.46s-4,1.45-4,2,.45,3.22.45,3.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.53,103.09s-4.93,1.61-4.93,2.37.26,3.32.26,3.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,100.11s-6.2,2.13-6.2,3.15a24.86,24.86,0,0,0,.51,3.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,113.65a4.75,4.75,0,0,0,2.15,1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,275.92l3.81,1.77s8.06-5,11.21-6.37,4.73-3.92,5.67-3.45-1.7,7.93-2.87,9.76-5.52,7.64-7,8.61-8.25,7.44-10.54,7.95-5.07-7.11-5.58-8.12-2.79-4.82-2.79-4.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.64,286.07c.51,1,3.3,8.62,5.58,8.12s9-7,10.54-7.95,5.87-6.78,7-8.61,3.81-9.3,2.87-9.76-2.51,2.05-5.67,3.45-11.21,6.37-11.21,6.37l.15,3.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.33,188.69s-6.41,9.7-8.49,16.64a13.7,13.7,0,0,0,6.24,15.49c4.16,2.31,16.19,4.85,20.81,5.55s30.75,1.39,30.75,1.39,9.06,23.47,12.3,28.56,13.64,20.11,13.64,20.11l4.16,8.56L328.07,275s-9.71-16.18-10.17-17.8-19.23-43.59-20.39-45-31.67-10.4-31.67-10.4S238.66,188.25,234.33,188.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,201.17s7.4-3.47,10.4-4.17,23.52,3.41,23.52,3.41",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,196.54a20.27,20.27,0,0,1,8.09-1.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmigration);
export default __webpack_public_path__ + "static/media/immigration.dc7c233fc78acae8821c17302c895809.svg";
export { ForwardRef as ReactComponent };